import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { TournamentFormatEnum, TournamentType } from '../../../enums/enums';
import { COLORS, TEXT_SIZES } from '../../../utils/constants';
import Modal from '../../common/Modal';
import CustomButton from '../../common/Button';

interface SportTypeModalProps {
  visible: boolean;
  onProceed: (selectedFormat: TournamentFormatEnum) => void;
  closeModal: () => void;
  tournamentType: TournamentType;
}

// Tournament formats data
const tournamentFormats = Object.keys(TournamentFormatEnum)
  .filter((key) => isNaN(Number(key)))
  .map((label) => {
    const value =
      TournamentFormatEnum[label as keyof typeof TournamentFormatEnum];

    let displayLabel = label;
    if (label === 'SingleElimination') displayLabel = 'Knockout';
    if (label === 'GroupStage') displayLabel = 'Groups';

    return {
      label: displayLabel,
      value,
    };
  })
  .filter(
    (item) =>
      item.value !== TournamentFormatEnum.Custom &&
      item.value !== TournamentFormatEnum.DoubleElimination,
  );

const SportTypeModal: React.FC<SportTypeModalProps> = ({
  visible,
  onProceed,
  closeModal,
  tournamentType,
}) => {
  const [selected, setSelected] = useState<TournamentFormatEnum>(
    TournamentFormatEnum.SingleElimination,
  );

  const filteredTournamentFormats = useMemo(() => {
    if (!tournamentFormats) return [];

    const isTeams = tournamentType === TournamentType.Team;

    return tournamentFormats.filter((tf) => {
      if (isTeams) {
        return tf.value !== TournamentFormatEnum.SingleElimination;
      } else {
        return true;
      }
    });
  }, [tournamentType]);

  return (
    <Modal
      title="Select Format"
      open={visible}
      onCancel={closeModal}
      width={400}
      minHeight={'auto'}
      footer={
        <CustomButton
          type="primary"
          onClick={() => onProceed(selected)}
          isDisabled={selected === null}
          isBlock
        >
          Proceed
        </CustomButton>
      }
    >
      <ModalContent>
        {filteredTournamentFormats.map((format) => (
          <Option
            key={format.value}
            selected={selected === format.value}
            onClick={() => setSelected(format.value)}
          >
            <OptionText>{format.label}</OptionText>
          </Option>
        ))}
      </ModalContent>
    </Modal>
  );
};
export default SportTypeModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px 0;
`;

const Option = styled.div<{ selected: boolean }>`
  width: 100%;
  padding: 14px;
  background-color: ${(props) =>
    props.selected ? COLORS.skyBlue.light : COLORS.grey.extraLight};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) =>
      props.selected ? COLORS.skyBlue.light : COLORS.grey.lightMedium};
  }
`;

const OptionText = styled.span`
  font-size: ${TEXT_SIZES.SM}px;
  color: ${COLORS.black.primary};
`;
